import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { ProjectUtilizationReport } from '../models/project-utilization-report.model';

@Injectable({ providedIn: 'root' })
export class ProjectUtilizationReportService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/ProjectUtilizationReport`;

  /**
   * Planned vs logged effort per project across an inclusive month range.
   *
   * @param includeDrafts when true (default) hours from unsubmitted work logs count towards
   *   actuals, so the report is usable before the period has closed.
   */
  getReport(
    startYear: number,
    startMonth: number,
    endYear: number,
    endMonth: number,
    includeDrafts = true
  ): Observable<ProjectUtilizationReport> {
    return this.http
      .get<ProjectUtilizationReport>(
        `${this.apiUrl}/${startYear}/${startMonth}/${endYear}/${endMonth}`,
        { params: { includeDrafts } }
      )
      .pipe(retry(2));
  }
}
